// visitorlistApi.js (Updated)
import {
  collection,
  doc,
  getDoc,
  query,
  where,
  orderBy,
  onSnapshot
} from "firebase/firestore";
import { db } from "../firebase";

// Fetch host details
export const fetchHostDetailsById = async (hostId) => {
  const hostDoc = await getDoc(doc(db, "users", hostId));
  if (hostDoc.exists() && hostDoc.data().role === 'host') {
    const hostData = hostDoc.data();
    return {
      name: hostData.userName || hostData.displayName || 'Unknown Host',
      companyName: hostData.companyName || hostData.tenantName || 'Not specified'
    };
  }
  return { name: 'Not Found', companyName: 'Not Found' };
};

// Subscribe to visits for visitor, appadmin, superadmin, or operator
export const subscribeToVisitHistory = (user, onSuccess, onError) => {
  let q;

  if (user?.role === 'visitor') {
    q = query(
      collection(db, "visit_approvals"),
      where("visitorUserID", "==", user.uid),
      orderBy("createdAt", "desc")
    );
  } else if (['appadmin', 'superadmin', 'operator'].includes(user?.role)) {
    q = query(
      collection(db, "visit_approvals"),
      orderBy("createdAt", "desc")
    );
  } else {
    // fallback to visitor-based query
    q = query(
      collection(db, "visit_approvals"),
      where("visitorUserID", "==", user.uid),
      orderBy("createdAt", "desc")
    );
  }

  return onSnapshot(q, onSuccess, onError);
};
